export default __webpack_public_path__ + "static/media/rails.380eb091.svg";